import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  const failures = ['Lo que intentaste antes fracasó porque dependía de productos físicos y altos costos de inventario.', 'No tuviste un plan paso a paso simple para validar tu idea rápidamente.', 'Te frenó el miedo a la tecnología y a las herramientas complicadas.', 'No encontraste una guía adaptada a personas con poco tiempo, que equilibre su vida personal y laboral.', 'Intentaste abarcar demasiadas cosas a la vez sin un enfoque claro.'];
  return <section className="py-24 px-6 lg:px-8 bg-white text-slate-900" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-119">
          <div className="inline-flex items-center justify-center p-3 bg-red-100 text-red-600 rounded-full mb-6" data-id="element-120">
            <AlertTriangle className="w-8 h-8" data-id="element-121" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6" data-id="element-122">
            La Frustración de Intentarlo y No Avanzar
          </h2>
          <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-123">
            Has intentado varias veces ganar dinero extra: vendiendo productos
            físicos, ofreciendo servicios locales, o probando con plataformas
            freelance. Pero te has topado con la misma frustración: no sabes por
            dónde empezar, te abruma la tecnología y sientes que el tiempo no te
            alcanza. Cada día que pasa, postergas tu proyecto una vez más, y la
            inestabilidad económica sigue ahí.
          </p>
        </motion.div>

        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-100 shadow-sm" data-id="element-124">
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-2xl font-bold mb-8 text-center" data-id="element-125">
            ¿Por qué lo que intentaste antes no funcionó?
          </motion.h3>

          <div className="space-y-4 max-w-3xl mx-auto" data-id="element-126">
            {failures.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm border border-slate-100" data-id="element-127">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-128" />
                <p className="text-slate-700 text-lg" data-id="element-129">{item}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}